// extracted by mini-css-extract-plugin
export default {"icon":"ApproveStatusIcon_icon__4OVeU","yes":"ApproveStatusIcon_yes__BELYq","no":"ApproveStatusIcon_no__ZxKsO"};